import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, forwardRef, HostBinding, Input, OnDestroy, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { SalesBonus, SalesBonusFilters } from 'src/app/commons/models/sales-bonus.model';

export const SALES_BONUSES_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => SalesBonusesFieldComponent),
};

@Component({
  selector: "app-sales-bonuses-field",
  templateUrl: "./sales-bonuses-field.component.html",
  styleUrls: ["./sales-bonuses-field.component.scss"],
  providers: [SALES_BONUSES_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class SalesBonusesFieldComponent
  implements OnDestroy, ControlValueAccessor, MatFormFieldControl<SalesBonus[]> {
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  private unsubscribe$ = new Subject<void>();

  private _value: SalesBonus[] = [];
  private _disabled = false;
  openEdit: boolean;
  currentSalesBonusIndex: number;

  private _required = false;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "sales-bonus-selection-field";
  autofilled?: boolean;
  salesBonusAriaDescribedBy?: string;

  @Input()
  salesBonuslFilters: SalesBonusFilters;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
  ) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() { }

  get currentSalesBonus(): SalesBonus {
    if (this.currentSalesBonusIndex >= 0)
      return this.value.at(this.currentSalesBonusIndex);
    return null;
  }

  open() {
    this.openEdit = true;
  };

  close() {
    this.openEdit = false;
  }

  addSalesBonus() {
    this.currentSalesBonusIndex = -1;
    this.open();
  }

  editSalesBonus(index: number) {
    this.currentSalesBonusIndex = index;
    this.open();
  }

  save(salesBonus: SalesBonus) {
    if (this.currentSalesBonusIndex >= 0) {
      this._value[this.currentSalesBonusIndex] = salesBonus;
      this.currentSalesBonusIndex = -1;
    } else {
      this._value.push(salesBonus);
    }

    this.notifyValueChange();
  }

  removeSalesBonus(index: number) {
    if (this.currentSalesBonusIndex === index) {
      this.currentSalesBonusIndex = -1;
      this.close();
    }

    this.value.splice(index, 1);
    this.notifyValueChange();
  }

  stateChanges = new Subject<void>();
  id: string;

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {

  }

  onContainerClick(event: MouseEvent): void {

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  @Input()
  set value(value: SalesBonus[]) {
    this._value = value;
    this.stateChanges.next();
  }

  get value(): SalesBonus[] {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: SalesBonus[]): void {
    this.value = [];
    if (obj) {
      this.value.push(...obj);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
